<template>
    <div>
        <div class="wrapper">
            <div class="col12 pt-0">
                <h1 class="page_title">機器レンタルプランのお申し込み</h1>
                <div class="signup_flow">
                    <ol>
                        <li><span>1</span>ログ <br class="on-sp" />イン</li>
                        <li><span>2</span>申込 <br class="on-sp" />内容</li>
                        <li class="current"><span>3</span>情報 <br class="on-sp" />入力</li>
                        <li><span>4</span>支払</li>
                        <li><span>5</span>完了</li>
                    </ol>
                </div>
                <!-- signup_flow -->
            </div>
        </div>
        <!-- wrapper -->
        <section class="container">
            <div class="wrapper">
                <h2 class="col5 section_title">
                    <strong> お申込み者様の情報 </strong>
                </h2>
                <div class="col7 wrap_pr_2col input_area">
                    <div v-show="needsBoccoAccountConnect && !connectedAccount">
                        <div>ネコリコアカウントと同じメールアドレスで既にBOCCOアカウントを持っている場合はアカウントを連携してください。</div>
                        <dl>
                            <dt>パスワード</dt>
                            <dd class="wrap_pw_input">
                                <input
                                    :type="yukaiPasswordVisible ? 'text' : 'password'"
                                    id="yukaiPassword"
                                    pattern="^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[!-~]{8,}$"
                                    v-model="yukaiPassword"
                                    autocomplete="new-password"
                                    :class="[yukaiPasswordInvalid ? 'invalid' : '']"
                                    required
                                    :readonly="connectedAccountThis"
                                />
                                <span
                                    class="field-icon"
                                    :class="{
                                        hide: yukaiPasswordVisible
                                    }"
                                    @touchstart="togglePassword($event)"
                                    @mousedown="togglePassword($event)"
                                >
                                    <i toggle class></i>
                                </span>
                            </dd>
                        </dl>
                        <p>
                            <a :class="[connectedAccountThis ? 'btn_round_s gray' : 'btn_round_s white cursor-pointer']" @click="connectAccount">アカウントを連携する</a>
                        </p>
                        <br />
                    </div>
                    <div>
                        <div>現在ご入力されているあなたの情報を入力してください。</div>
                        <dl>
                            <dt>お申込み者様の性別<span class="normal small ml-05em">必須</span></dt>
                            <dd>
                                <ul>
                                    <li v-for="(gender, key) in genders" :key="key">
                                        <input type="radio" class="radio-input" v-model="ownerGender" v-bind:id="`owner_${gender.value}`" v-bind:value="gender.value" />
                                        <label v-bind:for="`owner_${gender.value}`">{{ gender.label }}</label>
                                    </li>
                                </ul>
                            </dd>
                        </dl>
                        <dl>
                            <dt>お申込み者様の年代<span class="normal small ml-05em">必須</span></dt>
                            <dd>
                                <div class="wrap_select">
                                    <select name="owner_age_group" ref="ownerAgeGroup" v-model="ownerAgeGroup" :class="[ownerAgeGroupInvalid ? 'invalid' : '']" required="required">
                                        <option v-for="(ageGroup, key) in ageGroups" :key="key">
                                            {{ ageGroup }}
                                        </option>
                                    </select>
                                </div>
                                <!-- wrap_select -->
                            </dd>
                        </dl>
                        <dl>
                            <dt>お申込み者様のお住まいの地域<span class="normal small ml-05em">必須</span></dt>
                            <dd>
                                <dl>
                                    <dt>都道府県<span class="normal small ml-05em">必須</span></dt>
                                    <dd>
                                        <div class="wrap_select">
                                            <select name="owner_pref_name" ref="ownerPrefecture" v-model="ownerPrefecture" :class="[ownerPrefectureInvalid ? 'invalid' : '']" required="required">
                                                <option v-for="(prefecture, key) in prefectures" :key="key">
                                                    {{ prefecture }}
                                                </option>
                                            </select>
                                        </div>
                                        <!-- wrap_select -->
                                    </dd>
                                    <dt>地域<span class="normal small ml-05em">必須</span></dt>
                                    <dd>
                                        <div class="wrap_select">
                                            <select name="owner_area_name" ref="ownerArea" v-model="ownerArea" :class="[ownerAreaInvalid ? 'invalid' : '']" required="required">
                                                <option v-for="(area, key) in ownerAreas" :key="key">
                                                    {{ area }}
                                                </option>
                                            </select>
                                        </div>
                                        <!-- wrap_select -->
                                    </dd>
                                </dl>
                            </dd>
                        </dl>
                    </div>
                    <hr class="thick" />
                </div>

                <h2 class="col5 section_title">
                    <strong> お届け日時の設定 </strong>
                </h2>

                <div class="col7 wrap_pr_2col input_area">
                    <div>
                        emoのお届けする日時を指定してください。お届け日がサービス利用開始日となります。サービス利用開始日当日にご指定いただいたクレジットカードに初月の利用料金をご請求いたします。また、離島など遠方の地域をご指定いただいた場合は指定した日時でのお届けができない場合がございます。
                    </div>
                    <dl>
                        <dt>お届け日<span class="normal small ml-05em">必須</span></dt>
                        <dd>
                            <div class="wrap_select">
                                <select
                                    name="delivery_date"
                                    ref="deliveryDate"
                                    v-model="deliveryDate"
                                    v-on:change="changeDeliveryDate(deliveryDate)"
                                    :class="[deliveryDateInvalid ? 'invalid' : '']"
                                    required="required"
                                >
                                    <option v-for="(deliveryDate, key) of deliveryDates" :key="key" v-bind:value="key">
                                        {{ deliveryDate }}
                                    </option>
                                </select>
                            </div>
                            <!-- wrap_select -->
                        </dd>
                    </dl>
                    <dl>
                        <dt>お届け時間帯<span class="normal small ml-05em">必須</span></dt>
                        <dd>
                            <div class="wrap_select">
                                <select name="delivery_time" ref="deliveryTime" v-model="deliveryTime" :class="[deliveryTimeInvalid ? 'invalid' : '']" required="required">
                                    <option v-for="(deliveryTime, key) of deliveryTimes" :key="key" v-bind:value="key">
                                        {{ deliveryTime }}
                                    </option>
                                </select>
                            </div>
                            <!-- wrap_select -->
                        </dd>
                    </dl>
                    <hr class="thick" />
                </div>

                <h2 class="col5 section_title">
                    <strong> emoを利用する人の情報 </strong>
                </h2>
                <div class="col7 wrap_pr_2col input_area">
                    <div>主にemoを利用する人の情報を設定します。</div>
                    <dl>
                        <dt>emoを主に利用する人の名前<span class="normal small ml-05em">必須</span></dt>
                        <ul>
                            <li v-for="(name, key) in emoUserNames" :key="key">
                                <input type="radio" class="radio-input" v-model="emoUserName" v-bind:id="name" v-bind:value="name" v-on:change="changeEmoUserName(name)" />
                                <label v-bind:for="name">{{ name }}</label>
                            </li>
                        </ul>
                        <dd>
                            <input
                                ref="emoUserNameText"
                                v-model="emoUserNameText"
                                type="text"
                                placeholder="例）実名も可(最大10文字)"
                                :class="[emoUserNameTextInvalid ? 'invalid' : '']"
                                v-bind:disabled="!emoUserNameTextDisplayed"
                                maxlength="10"
                            />
                        </dd>
                    </dl>
                    <dl>
                        <dt>emoを主に利用する人の性別<span class="normal small ml-05em">必須</span></dt>
                        <dd>
                            <ul>
                                <li v-for="(gender, key) in genders" :key="key">
                                    <input type="radio" class="radio-input" v-model="emoUserGender" v-bind:id="`emo_user_${gender.value}`" v-bind:value="gender.value" />
                                    <label v-bind:for="`emo_user_${gender.value}`">{{ gender.label }}</label>
                                </li>
                            </ul>
                        </dd>
                    </dl>
                    <dl>
                        <dt>emoを主に利用する人の年代<span class="normal small ml-05em">必須</span></dt>
                        <dd>
                            <div class="wrap_select">
                                <select name="emo_user_age_group" ref="emoUserAgeGroup" v-model="emoUserAgeGroup" :class="[emoUserAgeGroupInvalid ? 'invalid' : '']" required="required">
                                    <option v-for="(ageGroup, key) in ageGroups" :key="key">
                                        {{ ageGroup }}
                                    </option>
                                </select>
                            </div>
                        </dd>
                    </dl>
                    <dl>
                        <dt>emoを主に利用する人のお住まいの地域<span class="normal small ml-05em">必須</span></dt>
                        <dd>
                            <dl>
                                <dt>都道府県<span class="normal small ml-05em">必須</span></dt>
                                <dd>
                                    <div class="wrap_select">
                                        <select name="emo_pref_name" ref="emoPrefecture" v-model="emoPrefecture" :class="[emoPrefectureInvalid ? 'invalid' : '']" required="required">
                                            <option v-for="(prefecture, key) in prefectures" :key="key">
                                                {{ prefecture }}
                                            </option>
                                        </select>
                                    </div>
                                </dd>
                                <dt>地域<span class="normal small ml-05em">必須</span></dt>
                                <dd>
                                    <div class="wrap_select">
                                        <select name="area_name" ref="emoArea" v-model="emoArea" :class="[emoAreaInvalid ? 'invalid' : '']" required="required">
                                            <option v-for="(area, key) in emoAreas" :key="key">
                                                {{ area }}
                                            </option>
                                        </select>
                                    </div>
                                </dd>
                            </dl>
                            <!-- wrap_select -->
                        </dd>
                    </dl>
                    <dl>
                        <dt>この方はあなたとどのような関係か教えてください。<span class="normal small ml-05em">必須</span></dt>
                        <div class="wrap_select">
                            <select
                                name="emoUserRelationship"
                                ref="emoUserRelationship"
                                v-model="emoUserRelationship"
                                :class="[emoUserRelationshipInvalid ? 'invalid' : '']"
                                required="required"
                                v-on:change="changeEmoUserRelationship"
                            >
                                <option v-for="(relationship, key) in relationships" :key="key">
                                    {{ relationship }}
                                </option>
                            </select>
                        </div>
                        <!-- その他入力欄 -->
                        <span v-if="emoUserRelationshipTextDisplayed">
                            <textarea
                                class="col12 col12-sp"
                                ref="emoUserRelationshipText"
                                :class="[emoUserRelationshipTextInvalid ? 'invalid' : '']"
                                v-model="emoUserRelationshipText"
                                placeholder="(最大140字)"
                                maxlength="140"
                            >
                            </textarea>
                        </span>
                    </dl>
                    <hr class="thick" />
                </div>

                <h2 class="col5 section_title">
                    <strong> ファーストメッセージ </strong>
                </h2>
                <div class="col7 wrap_pr_2col input_area">
                    <div>
                        emoが起動したらすぐにメッセージをお届けします。<br />例えばemoをプレゼントされる場合は、お贈りする方に「お誕生日おめでとう。これからもよろしくね。娘より」などと入れていただければ、emoが代わりにお伝えします。
                    </div>
                    <textarea class="col12 col12-sp" v-model="firstMessage" placeholder="(最大140字)" maxlength="140"></textarea>
                    <hr class="thick" />
                </div>

                <h2 class="col5 section_title">
                    <strong> アンケート </strong>
                </h2>
                <div class="col7 wrap_pr_2col input_area">
                    <div>emoを知った最初のきっかけを教えてください。<span class="normal small ml-05em">必須</span></div>
                    <div class="wrap_select">
                        <select name="ownerAnswer1" ref="ownerAnswer1" v-model="ownerAnswer1" :class="[ownerAnswer1Invalid ? 'invalid' : '']" required="required" v-on:change="changeAnswer1Select">
                            <option v-for="(answer1, key) in answers1" :key="key">
                                {{ answer1.answer }}
                            </option>
                        </select>
                    </div>
                    <div v-if="answer1SubAnswers?.length > 0" class="wrap_select">
                        <select
                            name="ownerAnswer1SubAnswer"
                            ref="ownerAnswer1SubAnswer"
                            v-model="ownerAnswer1SubAnswer"
                            :class="[ownerAnswer1SubAnswerInvalid ? 'invalid' : '']"
                            required="required"
                            v-on:change="changeAnswer1SubAnswerSelect"
                        >
                            <option v-for="(answer1SubAnswer, key) in answer1SubAnswers" :key="key">
                                {{ answer1SubAnswer }}
                            </option>
                        </select>
                    </div>
                    <!-- アンケート1自由入力欄 -->
                    <span v-if="visibleAnswer1Text">
                        <textarea
                            class="col12 col12-sp"
                            :class="[ownerAnswer1TextInvalid ? 'invalid' : '']"
                            v-model="ownerAnswer1Text"
                            v-bind:placeholder="answer1Placeholder + '(最大140字)'"
                            maxlength="140"
                        >
                        </textarea>
                    </span>
                    <p class="submit_btn">
                        <input type="submit" value="次へ" onsubmit="return false;" @click="confirm" />
                    </p>
                    <p class="submit_btn no-check no-arrow mt-3em">
                        <a href="javascript:void(0)" @click="cancel">キャンセル</a>
                    </p>
                </div>

                <!-- wrap_pr_2col input_area -->
            </div>
            <!-- wrapper -->
        </section>
        <!-- container -->
    </div>
</template>

<script>
export default {
    beforeRouteEnter(to, from, next) {
        // 特定の画面以外からの遷移は禁止
        if (from.name !== "ContractForm" && from.name !== "ContractConfirm" && from.name !== "Payment") {
            next({ name: "Top" });
            return;
        }
        next();
    },
    beforeRouteLeave(to, from, next) {
        // 「入力内容を修正」ボタンや、ブラウザで戻られた場合に、入力項目を復元する
        const paramsCopy = JSON.parse(JSON.stringify(this.params));
        for (const entry of Object.entries(paramsCopy)) {
            to.params[entry[0]] = entry[1];
        }
        to.params.ownerGender = this.ownerGender;
        to.params.ownerGenderLabel = this.genders.find((v) => v.value === this.ownerGender).label;
        to.params.ownerAgeGroup = this.ownerAgeGroup;
        to.params.ownerPrefecture = this.ownerPrefecture;
        to.params.ownerArea = this.ownerArea;
        to.params.deliveryDate = this.deliveryDate;
        to.params.deliveryDateLabel = this.deliveryDates[this.deliveryDate];
        to.params.deliveryTime = this.deliveryTime;
        to.params.deliveryTimeLabel = this.deliveryTimes[this.deliveryTime];
        to.params.emoPersonality = this.emoPersonality;
        to.params.emoUserName = this.emoUserName;
        to.params.emoUserNameText = this.emoUserNameText;
        to.params.emoUserGender = this.emoUserGender;
        to.params.emoUserGenderLabel = this.genders.find((v) => v.value === this.emoUserGender).label;
        to.params.emoUserAgeGroup = this.emoUserAgeGroup;
        to.params.emoPrefecture = this.emoPrefecture;
        to.params.emoArea = this.emoArea;
        to.params.emoUserRelationship = this.emoUserRelationship;
        to.params.emoUserRelationshipText = this.emoUserRelationshipText;
        to.params.firstMessage = this.firstMessage !== undefined ? this.firstMessage.trim() : this.firstMessage; // スペース対策

        to.params.changedOwnerPrefecture = false; // 「入力内容を修正」ボタンで戻った際にフラグを落とした状態とするため
        to.params.changedEmoPrefecture = false;

        to.params.ownerAnswer1 = this.ownerAnswer1;
        to.params.ownerAnswer1SubAnswer = this.ownerAnswer1SubAnswer;
        to.params.ownerAnswer1Text = this.ownerAnswer1Text;

        to.params.needsBoccoAccountConnect = this.needsBoccoAccountConnect;
        to.params.connectedAccount = this.connectedAccount !== undefined ? this.connectedAccount : this.connectedAccountThis; // 次のこの画面に戻ってきたときは連携済として扱うため、画面移動時に渡す
        to.params.emoUserUuid = this.emoUserUuid;
        to.params.isRequiredCredit = this.isRequiredCredit;
        next();
    },
    methods: {
        connectAccount: function () {
            if (this.connectedAccountThis) {
                return;
            }
            // 入力チェック (パスワード)
            this.yukaiPasswordInvalid = false;
            if (!this.yukaiPassword) {
                this.yukaiPasswordInvalid = true;
                const msg = "入力項目に不備があります。確認してください。";
                this.$emit("openAlertModal", msg, null);
                return;
            }
            this.$emit("showSpinner", "処理中です");
            this.$axios(
                "POST",
                "/setupEmoForm/connectAccount",
                {
                    email: this.customerEmail,
                    password: this.yukaiPassword
                },
                (res) => {
                    this.$emit("hideSpinner");
                    this.emoUserUuid = res.data.emoUserUuid;
                    this.connectedAccountThis = true;
                }
            );
        },
        togglePassword: function (event) {
            this.yukaiPasswordVisible = !this.yukaiPasswordVisible;
            if (event.cancelable) event.preventDefault();
        },
        toggleCopyAddress: function () {
            this.copyAddress = !this.copyAddress;
        },
        changeEmoUserName: function (emoUserName) {
            if (emoUserName === "自由入力") {
                this.emoUserNameTextDisplayed = true;
            } else {
                this.emoUserNameText = "";
                this.emoUserNameTextDisplayed = false;
            }
        },
        changeEmoUserRelationship: function () {
            if (this.emoUserRelationship === "その他") {
                this.emoUserRelationshipTextDisplayed = true;
            } else {
                this.emoUserRelationshipText = "";
                this.emoUserRelationshipTextDisplayed = false;
            }
        },
        changeAnswer1Select: function (event) {
            const selectedIndex = event.target.selectedIndex;
            if (this.ownerAnswer1 && this.answers1[selectedIndex].subAnswer) {
                // サブ選択肢あり
                this.answer1SubAnswers = this.answers1[selectedIndex].subAnswer;
                this.visibleAnswer1Text = false;
            } else if (this.ownerAnswer1) {
                // サブ選択肢なし
                this.visibleAnswer1Text = true;
                this.answer1SubAnswers = [];
                this.ownerAnswer1SubAnswer = "";
                this.answer1Placeholder = this.answers1[selectedIndex].placeholder;
            } else {
                this.visibleAnswer1Text = false;
                this.answer1SubAnswers = [];
                this.ownerAnswer1SubAnswer = "";
            }
            this.ownerAnswer1SubAnswerInvalid = false;
            this.ownerAnswer1Text = "";
            this.ownerAnswer1TextInvalid = false;
        },
        changeAnswer1SubAnswerSelect: function () {
            this.ownerAnswer1SubAnswerInvalid = false;
            this.visibleAnswer1Text = true;
            this.answer1Placeholder = this.answers1.find((e) => e.answer === this.ownerAnswer1).placeholder;
            this.ownerAnswer1Text = "";
            this.ownerAnswer1TextInvalid = false;
        },
        changeDeliveryDate: function (deliveryDate) {
            // 配送日を変更した場合、配送時間帯指定のリストを更新する
            this.$axios(
                "POST",
                "/setupEmoForm/deliveryInfo",
                {
                    deliveryMap: this.deliveryMap,
                    deliveryDates: this.deliveryDates,
                    deliveryDate: deliveryDate
                },
                (res) => {
                    this.$emit("hideSpinner");
                    this.deliveryTimes = res.data.deliveryTimes;
                    // 時間指定を未選択にする
                    this.deliveryTime = null;
                }
            );
        },
        confirm: async function () {
            try {
                // 入力チェック (必須チェック)
                let invalidElement = false;
                for (const key of [
                    "ownerAgeGroup",
                    "ownerPrefecture",
                    "ownerArea",
                    "emoUserAgeGroup",
                    "emoPrefecture",
                    "emoArea",
                    "emoUserRelationship",
                    "deliveryDate",
                    "deliveryTime",
                    "ownerAnswer1"
                ]) {
                    this[`${key}Invalid`] = false;
                    const input = this.$refs[key];
                    if (input.validationMessage || input.value.trim().length < 1) {
                        this[`${key}Invalid`] = true;
                        invalidElement = true;
                    }
                }

                // emoを利用する人の名前で「自由入力」を選択した場合はテキスト入力も必須チェックする
                this.emoUserNameTextInvalid = false;
                if (this.emoUserName === "自由入力") {
                    const input = this.$refs["emoUserNameText"];
                    if (!input.value || (input.value && input.value.trim().length < 1)) {
                        this.emoUserNameTextInvalid = true;
                        invalidElement = true;
                    }
                }

                // 関係で「その他」を選択した場合はテキスト入力も必須チェックする
                this.emoUserRelationshipTextInvalid = false;
                if (this.emoUserRelationship === "その他") {
                    const input = this.$refs["emoUserRelationshipText"];
                    if (!input.value || (input.value && input.value.trim().length < 1)) {
                        this.emoUserRelationshipTextInvalid = true;
                        invalidElement = true;
                    }
                }

                // アンケート1の必須チェック
                this.ownerAnswer1TextInvalid = false;
                if (this.answer1SubAnswers?.length > 0 && !this.ownerAnswer1SubAnswer) {
                    this.ownerAnswer1SubAnswerInvalid = true;
                    invalidElement = true;
                }
                if (this.visibleAnswer1Text) {
                    if (!this.ownerAnswer1Text || this.ownerAnswer1Text.trim().length < 1) {
                        this.ownerAnswer1TextInvalid = true;
                        invalidElement = true;
                    }
                }

                // 各項目の一通りのチェックを行った後、一つでもエラーがあれば「入力項目に不備があります」エラーを表示する
                if (invalidElement) {
                    throw new Error("入力項目に不備があります。確認してください。");
                }

                // Boccoアカウント連携が必要で、この画面で連携実施済(connectedAccountThis)・入力内容修正などで既に連携実施済(connectedAccount) のどちらでもない場合
                if (this.needsBoccoAccountConnect && !(this.connectedAccountThis || this.connectedAccount)) {
                    this.yukaiPasswordInvalid = true;
                    throw new Error("BOCCOアカウントとの連携が必要です。BOCCOアカウントのパスワードを入力後、[アカウントを連携する]をクリックしてください。");
                }
            } catch (err) {
                this.$emit("openAlertModal", err.message, null);
                return;
            }

            this.$router.push({
                name: "ContractConfirm"
            });
        },
        cancel: function () {
            this.$emit("openConfirmModal", "申込みをキャンセルしますか？", () => {
                // TOP画面へ遷移
                this.$router.push({
                    name: "Top",
                    params: {}
                });
            });
        }
    },
    data: function () {
        return {
            emoPersonality: "むかんしん",
            deliveryDate: "",
            deliveryDateInvalid: false,
            deliveryDates: "",
            deliveryTime: "",
            deliveryTimeInvalid: false,
            deliveryTimes: "",
            deliveryMap: {},
            // emoを利用する人の情報
            emoUserName: "",
            emoUserNameText: "",
            emoUserNameTextDisplayed: false,
            emoUserNames: ["ご主人様", "おじいちゃん", "おばあちゃん", "じいじ・ばあば", "自由入力"],
            emoUserNameTextInvalid: false,
            emoUserGender: "",
            emoUserGenderLabel: "",
            emoUserAgeGroup: "",
            emoUserAgeGroupInvalid: false,
            emoPrefecture: "",
            emoArea: "",
            emoAreaInvalid: false,
            // 申込者の情報
            ownerGender: "",
            ownerGenderLabel: "",
            ownerAgeGroup: "",
            ownerAgeGroupInvalid: false,
            ownerPrefecture: "",
            ownerArea: "",
            ownerAreaInvalid: false,
            // emoを利用する人と申込者の関係
            emoUserRelationship: "",
            emoUserRelationshipInvalid: false,
            emoUserRelationshipText: "",
            emoUserRelationshipTextInvalid: false,
            emoUserRelationshipTextDisplayed: false,
            relationships: ["", "一緒に暮らすパートナー", "一緒に暮らす親", "離れて暮らすパートナー", "離れて暮らす親", "本人", "その他"],
            yukaiPassword: "",
            yukaiPasswordVisible: false,
            yukaiPasswordInvalid: false,
            // 他画面からの引継ぎ情報
            customerEmail: "",
            customerPrefecture: "",
            customerCity: "",
            customerAddress: "",
            changedOwnerPrefecture: false,
            copyAddress: true,
            destinationPrefecture: "",
            destinationCity: "",
            destinationAddress: "",
            changedEmoPrefecture: false,
            needsBoccoAccountConnect: false,
            connectedAccountThis: false,
            connectedAccount: undefined,
            emoUserUuid: "",
            member: {},
            genders: [
                { value: "male", label: "男性" },
                { value: "female", label: "女性" },
                { value: "unspecified", label: "その他" }
            ],
            ageGroups: [
                "",
                "15歳未満",
                "15～20未満",
                "20～25未満",
                "25～30未満",
                "30～35未満",
                "35～40未満",
                "40～45未満",
                "45～50未満",
                "50～55未満",
                "55～60未満",
                "60～65未満",
                "65～70未満",
                "70～75未満",
                "75～80未満",
                "80～85未満",
                "85～90未満",
                "90～95未満",
                "95～100未満",
                "100歳～"
            ],
            areaList: {
                北海道: [
                    "宗谷地方",
                    "上川地方",
                    "留萌地方",
                    "石狩地方",
                    "空知地方",
                    "後志地方",
                    "網走地方",
                    "北見地方",
                    "紋別地方",
                    "根室地方",
                    "釧路地方",
                    "十勝地方",
                    "胆振地方",
                    "日高地方",
                    "渡島地方",
                    "檜山地方"
                ],
                青森県: ["津軽", "下北", "三八上北"],
                岩手県: ["内陸", "沿岸北部", "沿岸南部"],
                宮城県: ["東部", "西部"],
                秋田県: ["沿岸", "内陸"],
                山形県: ["村山", "置賜", "庄内", "最上"],
                福島県: ["中通り", "浜通り", "会津"],
                茨城県: ["北部", "南部"],
                栃木県: ["南部", "北部"],
                群馬県: ["南部", "北部"],
                埼玉県: ["南部", "北部", "秩父地方"],
                千葉県: ["北西部", "北東部", "南部"],
                東京都: ["東京地方", "伊豆諸島北部", "伊豆諸島南部", "小笠原地方"],
                神奈川県: ["東部", "西部"],
                新潟県: ["下越", "中越", "上越", "佐渡"],
                山梨県: ["中西部", "東部・富士五湖"],
                長野県: ["北部", "中部", "南部"],
                富山県: ["東部", "西部"],
                石川県: ["加賀", "能登"],
                福井県: ["嶺北", "嶺南"],
                岐阜県: ["美濃地方", "飛騨地方"],
                静岡県: ["中部", "伊豆", "東部", "西部"],
                愛知県: ["西部", "東部"],
                三重県: ["北中部", "南部"],
                滋賀県: ["南部", "北部"],
                京都府: ["北部", "南部"],
                大阪府: ["大阪"],
                兵庫県: ["南部", "北部"],
                奈良県: ["北部", "南部"],
                和歌山県: ["北部", "南部"],
                鳥取県: ["東部", "中・西部"],
                島根県: ["東部", "西部", "隠岐"],
                岡山県: ["南部", "北部"],
                広島県: ["南部", "北部"],
                山口県: ["西部", "中部", "東部", "北部"],
                徳島県: ["北部", "南部"],
                香川県: ["高松"],
                愛媛県: ["中予", "東予", "南予"],
                高知県: ["中部", "東部", "西部"],
                福岡県: ["福岡地方", "北九州", "筑豊地方", "筑後地方"],
                佐賀県: ["南部", "北部"],
                長崎県: ["南部", "北部", "壱岐対馬", "五島"],
                熊本県: ["熊本地方", "阿蘇地方", "天草地方", "球磨地方"],
                大分県: ["中部", "北部", "西部", "南部"],
                宮崎県: ["南部平野部", "北部平野部", "南部山沿い", "北部山沿い"],
                鹿児島県: ["奄美地方", "薩摩地方", "大隅地方", "種子島屋久島地方"],
                沖縄県: ["本島中南部", "本島北部", "久米島", "大東島地方", "宮古島地方", "石垣島地方", "与那国島地方"]
            },
            // アンケート1
            ownerAnswer1: "",
            ownerAnswer1SubAnswer: "",
            ownerAnswer1Text: "",
            visibleAnswer1Text: false,
            answers1: [
                {
                    answer: "",
                    type: "none"
                },
                {
                    answer: "広告を見た",
                    subAnswer: ["新聞・雑誌広告", "TV・ラジオ", "DM・折込", "インターネット"],
                    placeholder: "媒体名・閲覧場所を入力してください"
                },
                {
                    answer: "店頭展示を見た",
                    placeholder: "店舗名を入力してください"
                },
                {
                    answer: "家族・知人から紹介された",
                    placeholder: "関係性を入力してください（例：叔父、孫、同僚）"
                },
                {
                    answer: "自らネット検索で見つけた",
                    placeholder: "サイト名・検索ワードを入力してください（例：「Google」で「□□□　▲▲▲」と検索した）"
                },
                {
                    answer: "その他",
                    placeholder: ""
                }
            ],
            answer1SubAnswers: [],
            answer1Placeholder: "",
            ownerAnswer1Invalid: false,
            ownerAnswer1SubAnswerInvalid: false,
            ownerAnswer1TextInvalid: false,
            isRequiredCredit: true
        };
    },
    computed: {
        ownerAreas: function () {
            return this.areaList[this.ownerPrefecture];
        },
        emoAreas: function () {
            return this.areaList[this.emoPrefecture];
        }
    },
    created() {
        this.$emit("showSpinner", "処理中です");
        this.params = this.$route.params;

        // 会員情報
        this.connectedAccount = this.$route.params.connectedAccount;
        this.ownerGender = this.$route.params.ownerGender || "unspecified";
        this.ownerAgeGroup = this.$route.params.ownerAgeGroup || "";
        this.customerEmail = this.$route.params.customerEmail;
        this.customerPrefecture = this.$route.params.customerPrefecture ? this.$route.params.customerPrefecture : "";
        this.customerCity = this.$route.params.customerCity;
        this.customerAddress = this.$route.params.customerAddress;
        this.changedOwnerPrefecture = this.$route.params.changedOwnerPrefecture;
        if (this.changedOwnerPrefecture || !this.$route.params.ownerPrefecture) {
            this.ownerPrefecture = this.customerPrefecture;
            this.ownerArea = "";
        } else {
            this.ownerPrefecture = this.$route.params.ownerPrefecture;
            this.ownerArea = this.$route.params.ownerArea || "";
        }
        // 配送先
        this.copyAddress = this.$route.params.copyAddress === undefined ? false : this.$route.params.copyAddress;
        this.destinationPrefecture = this.$route.params.destinationPrefecture ? this.$route.params.destinationPrefecture : "";
        this.destinationCity = this.$route.params.destinationCity;
        this.destinationAddress = this.$route.params.destinationAddress;
        this.changedEmoPrefecture = this.$route.params.changedEmoPrefecture;
        if (this.changedEmoPrefecture || !this.$route.params.emoPrefecture) {
            if (this.copyAddress) {
                this.emoPrefecture = this.customerPrefecture;
                this.emoArea = "";
            } else {
                this.emoPrefecture = this.destinationPrefecture;
                this.emoArea = "";
            }
        } else {
            this.emoPrefecture = this.$route.params.emoPrefecture;
            this.emoArea = this.$route.params.emoArea || "";
        }
        // emo設定情報
        this.emoUserName = this.$route.params.emoUserName || "ご主人様";
        this.emoUserNameText = this.$route.params.emoUserNameText;
        if (this.$route.params.emoUserName === "自由入力") {
            this.emoUserNameTextDisplayed = true;
        }
        this.emoUserGender = this.$route.params.emoUserGender || "unspecified";
        this.emoUserAgeGroup = this.$route.params.emoUserAgeGroup || "";
        this.emoUserRelationship = this.$route.params.emoUserRelationship || "";
        this.emoUserRelationshipText = this.$route.params.emoUserRelationshipText;
        if (this.emoUserRelationship === "その他") {
            this.emoUserRelationshipTextDisplayed = true;
        }

        this.prefectures = Object.keys(this.areaList);
        this.firstMessage = this.$route.params.firstMessage;

        // アンケート
        this.ownerAnswer1 = this.$route.params.ownerAnswer1 || "";
        this.ownerAnswer1SubAnswer = this.$route.params.ownerAnswer1SubAnswer || "";
        this.ownerAnswer1Text = this.$route.params.ownerAnswer1Text;

        if (this.ownerAnswer1SubAnswer) {
            this.answer1SubAnswers = this.answers1.find((e) => e.answer === this.ownerAnswer1).subAnswer;
        }
        if (this.ownerAnswer1Text) {
            this.visibleAnswer1Text = true;
        }

        // 配送日情報
        // 郵便番号から配送可能日を算出してリストを取得する(7日分表示)
        let prefecture = this.customerPrefecture;
        let city = this.customerCity + this.customerAddress;
        if (!this.copyAddress) {
            prefecture = this.destinationPrefecture;
            city = this.destinationCity + this.destinationAddress;
        }
        this.$axios(
            "POST",
            "/setupEmoForm/init",
            {
                prefecture: prefecture,
                city: city
            },
            (res) => {
                this.deliveryMap = res.data.deliveryMap;
                this.deliveryDates = res.data.deliveryDates;
                this.deliveryTimes = res.data.deliveryTimes;
                // Boccoアカウント連携が必要かチェック
                if (this.$route.params.needsBoccoAccountConnect === undefined) {
                    this.$axios("GET", "/setupEmoForm/emoOwnerInfo", null, (res) => {
                        // eslint-disable-line
                        // this.$emit('hideSpinner');
                        if (res.data && res.data.emoOwnerInfo) {
                            this.member = res.data.emoOwnerInfo.member;
                            this.emoUserUuid = this.member && this.member.uuid;
                            this.needsBoccoAccountConnect = res.data.emoOwnerInfo.needsBoccoAccountConnect;
                            this.$emit("hideSpinner");
                        }
                    });
                } else {
                    this.emoUserUuid = this.$route.params.emoUserUuid;
                    this.needsBoccoAccountConnect = this.$route.params.needsBoccoAccountConnect;
                    this.$emit("hideSpinner");
                }
            }
        );
        this.isRequiredCredit = this.$route.params.isRequiredCredit;
    }
};
</script>
<style scoped>
label > img {
    width: 100px;
    height: auto;
}
.input_area textarea {
    background: #f7f7f7;
    padding: 1px;
    height: calc(1.8em * 3);
}
.input_area textarea.invalid {
    background: #f2f4a6;
}
.input_area label.invalid {
    background: #f2f4a6;
}
</style>
